'use client';

import { usePathname, useRouter } from 'next/navigation';
import { FC, PropsWithChildren, useCallback, useEffect } from 'react';
import { useGlossaryContext } from './GlossaryContext';

const GlossaryRouterProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const router = useRouter();
  const pathname = usePathname();

  const { hasGlossary, isChecking } = useGlossaryContext();

  const onLoad = useCallback(async () => {
    if (!isChecking) {
      if (pathname.endsWith('/glossary') || pathname.endsWith('/glossary/list')) {
        if (!!hasGlossary && !pathname.endsWith('/glossary/list'))
          return router.push('/glossary/list');
      }
    }
  }, [hasGlossary, isChecking, pathname, router]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return <>{children}</>;
};

export default GlossaryRouterProvider;
